import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const darktrace = defineConnector({
  identifier: "darktrace",
  name: "Darktrace",
  tagLine: "AI-powered threat detection",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ applianceUrl }) => domainToRegex(applianceUrl),
  auth: customAuth("darktrace"),
  steps: [
    {
      title: "Get your Darktrace API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. In the Darktrace Threat Visualizer, go to **System Config › API Tokens**
2. Create a new token pair
3. Copy the public and private tokens`,
        },
      ],
    },
    {
      title: "Enter your Darktrace details",
      items: [
        {
          kind: "url",
          label: "Appliance URL",
          required: true,
          placeholder: "https://darktrace.example.com",
          target: { kind: "configuration", field: "applianceUrl" },
          helperText: "The base URL of your Darktrace appliance.",
        },
        {
          kind: "input",
          label: "Public token",
          required: true,
          target: { kind: "secrets", field: "publicToken" },
        },
        {
          kind: "input",
          label: "Private token",
          required: true,
          target: { kind: "secrets", field: "privateToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ applianceUrl }) => `${applianceUrl}/status`,
  },
});
